import React, { createContext, useEffect, useRef, useState } from "react"
import { randomBytes } from "crypto"

const ViewportContext = createContext([])

const ViewportProvider = ({ children }) => {
  const currentWidthHeight = useRef([])
  const initialWidthHeight = () => {
    if (window) return [window.innerWidth, window.innerHeight]
    return [0, 0]
  }
  const [dimensions, setDimensions] = useState(initialWidthHeight())

  useEffect(() => {
    const resizeViewportHandle = () => {
      let difference
      if (currentWidthHeight.current[0] === window.innerWidth) {
        difference = window.innerHeight - currentWidthHeight.current[1]
        if (
          window.innerWidth > 640 ||
          ((difference > 119 || difference < -119) &&
            currentWidthHeight.current[1] !== window.innerHeight &&
            window.innerWidth < 641)
        ) {
          currentWidthHeight.current[1] = window.innerHeight
          setDimensions(currentWidthHeight.current)
        }
      } else {
        currentWidthHeight.current = [window.innerWidth, window.innerHeight]
        setDimensions(currentWidthHeight.current)
      }
    }
    resizeViewportHandle()
    let resizeViewportThrottle
    const resizeViewportThrottleFunction = () => {
      if (resizeViewportThrottle) clearTimeout(resizeViewportThrottle)
      resizeViewportThrottle = setTimeout(resizeViewportHandle, 0)
    }

    window.addEventListener("resize", () => resizeViewportThrottleFunction())
    return () =>
      window.removeEventListener("resize", () =>
        resizeViewportThrottleFunction()
      )
  }, [])

  return (
    <ViewportContext.Provider
      key={randomBytes(6).toString("hex")}
      value={dimensions}
    >
      {children}
    </ViewportContext.Provider>
  )
}

export { ViewportContext, ViewportProvider }
